import { c as _c } from "react/compiler-runtime";
import { CommunityMemberOverview, CIC_TO_TEXT } from "@/entities/IProfile";
import { formatNumberWithCommasOrDash, cicToType } from "@/helpers/Helpers";
import UserLevel from "@/components/user/utils/level/UserLevel";
import { Tooltip } from "react-tooltip";
import UserCICTypeIcon from "@/components/user/utils/user-cic-type/UserCICTypeIcon";
import { isEthereumAddress, isAutoGeneratedHandle } from "@/helpers/AllowlistToolHelpers";
import { ImageScale, getScaledImageUri } from "@/helpers/image.helpers";
import CommonTimeAgo from "@/components/utils/CommonTimeAgo";
import Link from "next/link";
export default function CommunityMembersMobileCard(t0) {
  const $ = _c(70);
  const {
    member,
    rank
  } = t0;
  const isNotProfile = isEthereumAddress(member.detail_view_key);
  const isProfile = !isNotProfile;
  const textColorClass = isProfile ? "tw-text-iron-50" : "tw-text-iron-400";
  const path = `/${member.detail_view_key}`;
  let t1;
  if ($[0] !== rank) {
    t1 = <span className="tw-text-iron-400 tw-text-xs tw-w-5 tw-flex-shrink-0">#{rank}</span>;
    $[0] = rank;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== member.display || $[3] !== member.pfp) {
    t2 = member.pfp && <img src={getScaledImageUri(member.pfp, ImageScale.W_AUTO_H_50)} alt={`${member.display} avatar`} className="tw-h-full tw-w-full tw-object-contain tw-mx-auto" />;
    $[2] = member.display;
    $[3] = member.pfp;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <div className={"tw-flex-shrink-0 tw-h-11 tw-w-11 tw-rounded-md tw-overflow-hidden tw-ring-1 tw-ring-white/10 tw-bg-iron-900 tw-flex tw-items-center \n          tw-justify-center"}>{t2}</div>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = `tw-overflow-hidden ${isEthereumAddress(member.detail_view_key) || isAutoGeneratedHandle(member.detail_view_key) ? "tw-max-w-[8rem] tw-truncate" : ""}`;
  const t5 = `tw-text-sm tw-font-medium ${textColorClass}`;
  let t6;
  if ($[7] !== member.display || $[8] !== t5) {
    t6 = <span className={t5}>{member.display}</span>;
    $[7] = member.display;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t4 || $[11] !== t6) {
    t7 = <div className="tw-flex tw-items-center -tw-mt-1"><div className={t4}>{t6}</div></div>;
    $[10] = t4;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== member.level) {
    t8 = <UserLevel level={member.level} size="xs" />;
    $[13] = member.level;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t7 || $[16] !== t8) {
    t9 = <div className="tw-flex tw-flex-col tw-items-start tw-gap-y-1.5 tw-min-w-0">{t7}{t8}</div>;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t3 || $[19] !== t9) {
    t10 = <div className="tw-flex tw-items-start tw-gap-x-3">{t3}{t9}</div>;
    $[18] = t3;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== member.last_activity) {
    t11 = member.last_activity && <div className="tw-flex tw-items-center tw-gap-x-1 tw-ml-auto tw-self-start"><span className="tw-text-iron-400 tw-text-xs">Active</span><span className="tw-text-iron-400 tw-text-xs"><CommonTimeAgo timestamp={member.last_activity} short={true} className="tw-text-xs" /></span></div>;
    $[21] = member.last_activity;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t10 || $[24] !== t11) {
    t12 = <div className="tw-flex tw-justify-between tw-w-full">{t10}{t11}</div>;
    $[23] = t10;
    $[24] = t11;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== member.tdh) {
    t13 = formatNumberWithCommasOrDash(member.tdh);
    $[26] = member.tdh;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t13) {
    t14 = <span className="tw-font-semibold tw-text-iron-50 tw-text-xxs">{t13}</span>;
    $[28] = t13;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <span className="tw-text-iron-400 tw-text-xxs">TDH</span>;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== t14) {
    t16 = <div className="tw-flex tw-items-baseline tw-gap-x-1">{t14}{t15}</div>;
    $[31] = t14;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== member.rep) {
    t17 = formatNumberWithCommasOrDash(member.rep);
    $[33] = member.rep;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] !== t17) {
    t18 = <span className="tw-font-semibold tw-text-iron-50 tw-text-xxs">{t17}</span>;
    $[35] = t17;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  let t19;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <span className="tw-text-iron-400 tw-text-xxs">REP</span>;
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  let t20;
  if ($[38] !== t18) {
    t20 = <div className="tw-flex tw-items-baseline tw-gap-x-1">{t18}{t19}</div>;
    $[38] = t18;
    $[39] = t20;
  } else {
    t20 = $[39];
  }
  let t21;
  if ($[40] !== member.cic) {
    t21 = formatNumberWithCommasOrDash(member.cic);
    $[40] = member.cic;
    $[41] = t21;
  } else {
    t21 = $[41];
  }
  let t22;
  if ($[42] !== t21) {
    t22 = <span className="tw-font-semibold tw-text-iron-50 tw-text-xxs">{t21}</span>;
    $[42] = t21;
    $[43] = t22;
  } else {
    t22 = $[43];
  }
  const t23 = `cic-tooltip-${member.detail_view_key}`;
  let t24;
  if ($[44] !== member.cic) {
    t24 = <UserCICTypeIcon cic={member.cic} />;
    $[44] = member.cic;
    $[45] = t24;
  } else {
    t24 = $[45];
  }
  let t25;
  if ($[46] !== t23 || $[47] !== t24) {
    t25 = <span className="tw-h-4 tw-w-4 tw-flex-shrink-0" data-tooltip-id={t23}>{t24}</span>;
    $[46] = t23;
    $[47] = t24;
    $[48] = t25;
  } else {
    t25 = $[48];
  }
  const t26 = `cic-tooltip-${member.detail_view_key}`;
  let t27;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = {
      backgroundColor: "#1F2937",
      color: "white",
      padding: "4px 8px"
    };
    $[49] = t27;
  } else {
    t27 = $[49];
  }
  const t28 = CIC_TO_TEXT[cicToType(member.cic)];
  let t29;
  if ($[50] !== t26 || $[51] !== t28) {
    t29 = <Tooltip id={t26} place="top" style={t27}>{t28}</Tooltip>;
    $[50] = t26;
    $[51] = t28;
    $[52] = t29;
  } else {
    t29 = $[52];
  }
  let t30;
  if ($[53] !== t22 || $[54] !== t25 || $[55] !== t29) {
    t30 = <div className="tw-flex tw-items-center tw-gap-x-1">{t22}{t25}{t29}</div>;
    $[53] = t22;
    $[54] = t25;
    $[55] = t29;
    $[56] = t30;
  } else {
    t30 = $[56];
  }
  let t31;
  if ($[57] !== t16 || $[58] !== t20 || $[59] !== t30) {
    t31 = <div className="tw-mt-4 tw-flex tw-items-center tw-gap-x-3 tw-whitespace-nowrap tw-justify-between">{t16}{t20}{t30}</div>;
    $[57] = t16;
    $[58] = t20;
    $[59] = t30;
    $[60] = t31;
  } else {
    t31 = $[60];
  }
  let t32;
  if ($[61] !== t12 || $[62] !== t31) {
    t32 = <div className="tw-flex tw-flex-col tw-w-full">{t12}{t31}</div>;
    $[61] = t12;
    $[62] = t31;
    $[63] = t32;
  } else {
    t32 = $[63];
  }
  let t33;
  if ($[64] !== t1 || $[65] !== t32) {
    t33 = <div className="tw-flex tw-items-start tw-gap-x-3">{t1}{t32}</div>;
    $[64] = t1;
    $[65] = t32;
    $[66] = t33;
  } else {
    t33 = $[66];
  }
  let t34;
  if ($[67] !== path || $[68] !== t33) {
    t34 = <Link href={path} className="tw-flex tw-flex-col tw-gap-y-3 tw-pt-4 tw-pb-3 tw-pl-3 tw-pr-4 tw-rounded-xl tw-bg-iron-900/80 tw-border tw-border-iron-800 tw-border-solid tw-backdrop-blur-md active:tw-bg-iron-800 tw-transition-all tw-duration-200 tw-no-underline tw-overflow-hidden tw-shadow-sm tw-shadow-black/20">{t33}</Link>;
    $[67] = path;
    $[68] = t33;
    $[69] = t34;
  } else {
    t34 = $[69];
  }
  return t34;
}